<template>
  <div class="bg">
    <div class="pageTop1">
      <div style="margin-bottom: 30px">
        <FxedTop></FxedTop>
      </div>
    </div>
    <div class="pageTitle" style="width: 1200px">
      <div class="sort"></div>
      <div class="currentLocation">当前位置：首页 > 登记表</div>
    </div>
    <div class="education-record">
      <!-- 个人信息表格 -->
      <div style="margin-bottom: 20px; padding: 20px 40px; background: #fff" ref="printPdfpage">
        <!-- 标题 -->
        <div class="record-title">
          {{ classYear }}年度专业技术人员继续教育情况登记表
        </div>
        <table class="info-table" border="1">
          <tr>
            <td class="avatar-cell" rowspan="4" colspan="2">
              <canvas ref="avatarCanvas" class="avatarCanvas"></canvas>
            </td>
            <td style="width: 100px">姓名</td>
            <td style="width: 100px">{{ info.realName }}</td>
            <td style="width: 100px">性别</td>
            <td style="width: 100px">{{ info.gender == 1 ? "男" : "女" }}</td>
            <td style="width: 100px">民族</td>
            <td style="width: 100px">
              <span v-for="(item, index) in json_mz" :key="index">
                <span v-if="item.code == info.nationality">
                  {{ item.value }}
                </span>
              </span>
            </td>
            <td class="qr-cell" rowspan="3">
              <canvas ref="qrCanvas" class="qrCanvas" style="width: 100px; height: 100px"></canvas>
            </td>
          </tr>
          <tr>
            <td>身份证号</td>
            <td colspan="2">{{ info.idCardNo }}</td>
            <td>参工时间</td>
            <td colspan="2">{{ info.joinWorkDate }}</td>
          </tr>
          <tr>
            <td>政治面貌</td>
            <td>
              <span v-for="(item, index) in json_zzmm" :key="index">
                <span v-if="item.code == info.politicalStatus">
                  {{ item.value }}
                </span>
              </span>
            </td>
            <td colspan="1">学历</td>
            <td colspan="3">
              {{ getXw_XlName("xl", info.educationalBackground) }}
            </td>
          </tr>
          <tr>
            <td>工作单位</td>
            <td colspan="6">
              {{ info.schoolName }}
            </td>
          </tr>
          <tr>
            <td colspan="2">联系电话</td>
            <td colspan="7">
              {{ info.phoneNumber }}
            </td>
          </tr>
          <tr>
            <td colspan="2">职称等级</td>
            <td colspan="7">
              <span v-if="info.professionalTitle == 0">未评</span>
              <span v-if="info.professionalTitle == 1">初级</span>
              <span v-if="info.professionalTitle == 2">中级</span>
              <span v-if="info.professionalTitle == 3">高级</span>
            </td>
          </tr>
          <tr style="text-align: center">
            <td colspan="9">公需科目学时登记记录</td>
          </tr>
          <tr style="text-align: center">
            <td colspan="9">
              {{ publicSubjectDesc }}
            </td>
          </tr>
          <tr style="text-align: center">
            <td colspan="9">专业科目学时登记记录</td>
          </tr>
          <tr>
            <td style="width: 90px">举办部门</td>
            <td style="width: 80px">学习形式</td>
            <td style="width: 120px">学习地点</td>
            <td>学习内容</td>
            <td style="width: 80px" colspan="2">学习起止时间</td>
            <td style="width: 80px" colspan="2">学时</td>
            <td style="width: 80px">验证人</td>
          </tr>
          <tr v-for="(item, idx) in publicSubjects" :key="'pub-' + idx">
            <td>{{ item.department }}</td>
            <td>{{ item.learnMethodName }}</td>
            <td>{{ item.learnLocation }}</td>
            <td>{{ item.courseTitle }}</td>
            <td colspan="2">
              {{ item.startTime ? item.startTime : "" }}
              <span style="margin: 0 5px">-</span>
              {{ item.endTime ? item.endTime : "" }}
            </td>
            <td colspan="2">{{ item.learnHour }}</td>
            <td>{{ item.approvalPerson }}</td>
          </tr>
          <tr>
            <td rowspan="2" colspan="2">年度累计学时</td>
            <td>专业科目</td>
            <td>公需科目</td>
            <td rowspan="2" colspan="2">年度完成情况</td>
            <td colspan="2">专业科目</td>
            <td>公需科目</td>
          </tr>
          <tr>
            <td>{{ stat.major }}</td>
            <td>{{ stat.public }}</td>
            <td colspan="2">{{ stat.majorStatus }}</td>
            <td>{{ stat.publicStatus }}</td>
          </tr>
          <tr style="height: 100px">
            <td>所在单位审核意见</td>
            <td colspan="4"></td>
            <td>地（市）人社部门或区直行业主管部门审核意见</td>
            <td colspan="3" style="text-align: center">
              {{
                stat.majorStatus == "已完成" && stat.publicStatus == "已完成"
                  ? "通过"
                  : "未通过"
              }}
            </td>
          </tr>
        </table>
      </div>
      <div class="button-container">
        <div @click="print" class="print jrwdkc2">打印预览</div>
        <div @click="generatePDF" class="print jrwdkc2">下载PDF</div>
      </div>
    </div>
    <Footer></Footer>
  </div>
</template>

<script>
import FxedTop from "@/components/FxedTop";
import Footer from "@/components/Footer.vue";
import { getUserInfo } from "@/api/user";
import { offlineRecognitionList, getSchoolClassLearnRecord } from "@/api/wkApi";
import printJS from "print-js";
import html2canvas from "html2canvas";

import json_mz from "@/assets/json/json_mz";
import json_xl from "@/assets/json/json_xl";
import json_xw from "@/assets/json/json_xw";
import json_zzmm from "@/assets/json/json_zzmm";
import json_dq from "@/assets/json/json_dq";
import new_json_xl from "@/assets/json/new_json_xl";
import new_json_xw from "@/assets/json/new_json_xw";

import json_zy from "@/assets/json/json_zy";

// 导入jspdf
import { jsPDF } from "jspdf";
import QRCode from "qrcode";
export default {
  components: {
    Footer,
    FxedTop,
  },
  data() {
    return {
      json_mz,
      json_xl,
      json_xw,
      json_zzmm,
      json_dq,
      new_json_xl,
      new_json_xw,
      json_zy,
      info: {},
      publicSubjects: [{}],
      stat: {
        major: undefined,
        public: undefined,
        majorStatus: undefined,
        publicStatus: undefined,
      },
      publicSubjectDesc: "",
      classYear: undefined,
      userClass: {},
      userClass2: {},
    };
  },
  created() {
    this.classYear = this.$route.query.classYear;
    this.getUserInfo();
    this.getList();
    this.getSchoolClassLearnRecord();
  },
  methods: {
    getXw_XlName(type, code) {
      let name = "";
      if (type == "xw") {
        this.new_json_xw.forEach((item) => {
          if (item.code == code) {
            name = item.value;
          }
          if (item.isParent) {
            item.sub.forEach((itemm) => {
              if (itemm.code == code) {
                name = itemm.value;
              }
            });
          }
        });
      }
      if (type == "xl") {
        this.new_json_xl.forEach((item) => {
          if (item.code == code) {
            name = item.value;
          }
          if (item.isParent) {
            item.sub.forEach((itemm) => {
              if (itemm.code == code) {
                name = itemm.value;
              }
            });
          }
        });
      }
      if (type == "zy") {
        this.json_zy.forEach((item) => {
          if (item.code == code) {
            name = item.value;
          }
          if (item.sub.length > 0) {
            item.sub.forEach((itemm) => {
              if (itemm.code == code) {
                name = itemm.value;
              }
              if (itemm.sub.length > 0) {
                itemm.sub.forEach((itemmm) => {
                  if (itemmm.code == code) {
                    name = itemmm.value;
                  }
                });
              }
            });
          }
        });
      }
      return name;
    },
    // 获取课程学习记录
    async getSchoolClassLearnRecord() {
      const res1 = await getSchoolClassLearnRecord({
        classYear: this.classYear,
        courseType: "1",
      });
      this.userClass1 = res1.result || {};
      this.publicSubjectDesc = `${this.classYear}年度公需科目共计获得${this.userClass1.haveRequiredCourseHour +
        this.userClass1.haveOptionalCourseHour
        }学时`;
      const res2 = await getSchoolClassLearnRecord({
        classYear: this.classYear,
        courseType: "2",
      });
      this.userClass2 = res2.result || {};

      this.stat = {
        major:
          this.userClass2.haveRequiredCourseHour +
          this.userClass2.haveOfflineLearnHour +
          this.userClass2.haveOptionalCourseHour,
        public:
          this.userClass1.haveRequiredCourseHour +
          this.userClass1.haveOptionalCourseHour,
        majorStatus:
          this.userClass2.haveRequiredCourseHour +
            this.userClass2.haveOptionalCourseHour +
            this.userClass2.haveOfflineLearnHour >=
            this.userClass2.requiredCourseHour +
            this.userClass2.optionalCourseHour
            ? "已完成"
            : "未完成",
        publicStatus:
          this.userClass1.haveRequiredCourseHour +
            this.userClass1.haveOptionalCourseHour >=
            this.userClass1.requiredCourseHour +
            this.userClass1.optionalCourseHour
            ? "已完成"
            : "未完成",
      };
    },
    async getUserInfo() {
      try {
        let res = await getUserInfo();
        if (res.code == 200) {
          this.info = res.data;

          this.$nextTick(() => {
            let url = `${window.location.origin}/h5/#/pages/newEducationRecord/index?userId=${this.info.id}&classYear=${this.classYear}`;
            if (window.location.href.indexOf('migrate') != -1) {
              url = `${window.location.origin}/migrate/h5/#/pages/newEducationRecord/index?userId=${this.info.id}&classYear=${this.classYear}`;
            }
            const canvas = this.$refs.qrCanvas;
            QRCode.toCanvas(
              canvas,
              url,
              {
                width: 100,
                height: 100,
              },
              (error) => {
                if (error) console.error(error);
              }
            );
            // 直接使用Canvas绘制头像
            this.drawAvatarToCanvas();
          });
        }
      } catch (error) { }
    },

    getList(envt) {
      offlineRecognitionList({
        recognitionStatus: "3",
        pageSize: 10000,
        pageNo: 1,
        learnYear: this.classYear,
      }).then((res) => {
        if (res.result.records && res.result.records.length > 0) {
          this.publicSubjects = res.result.records;
        } else {
          this.publicSubjects = [{}];
        }
      });
    },

    print() {
      html2canvas(this.$refs.printPdfpage).then((canvas) => {
        let saveUrl = canvas.toDataURL("image/png");
        printJS({
          printable: [saveUrl],
          type: "image",
          style: `@media print { @page {size:auto; margin: 0} body{margin:0 5px}}`,
        });
      });
    },

    // 生成PDF
    generatePDF() {
      const element = this.$refs.printPdfpage;
      const pdfName = "登记表-" + new Date().getTime() + ".pdf";
      html2canvas(element, {
        scale: 2, // 提高画布清晰度
        useCORS: true, // 允许跨域图片
        logging: false, // 不显示日志
        backgroundColor: null, // 保持透明背景
      }).then((canvas) => {
        const imgData = canvas.toDataURL("image/jpeg", 1.0);
        const pdf = new jsPDF({
          orientation: "portrait",
          unit: "mm",
          format: "a4",
        });

        // 计算宽高比
        const imgWidth = 210; // A4宽度，单位mm
        const pageHeight = 297; // A4高度，单位mm
        const imgHeight = (canvas.height * imgWidth) / canvas.width;
        let heightLeft = imgHeight;
        let position = 0;
        // 添加第一页
        pdf.addImage(imgData, "JPEG", 0, position, imgWidth, imgHeight);
        heightLeft -= pageHeight;
        // 如果内容超过一页，添加新页
        while (heightLeft > 0) {
          position = heightLeft - imgHeight;
          pdf.addPage();
          pdf.addImage(imgData, "JPEG", 0, position, imgWidth, imgHeight);
          heightLeft -= pageHeight;
        }
        // 保存PDF
        pdf.save(pdfName);
      });
    },

    // 直接使用Canvas绘制头像
    drawAvatarToCanvas() {
      const canvas = this.$refs.avatarCanvas;
      if (!canvas) {
        console.error("Canvas元素未找到");
        return;
      }

      const ctx = canvas.getContext("2d");
      const size = 100; // 头像尺寸

      // 设置canvas尺寸
      canvas.width = size;
      canvas.height = size;

      // 清空canvas
      ctx.clearRect(0, 0, size, size);

      // 创建圆形裁剪区域
      ctx.save();
      ctx.beginPath();

      // 如果有头像URL，加载并绘制
      if (this.info && this.info.certificateHeadPhoto) {
        const img = new Image();
        img.crossOrigin = "anonymous";
        img.onload = () => {
          // 计算绘制参数，保持宽高比
          const scale = Math.max(size / img.width, size / img.height);
          const drawWidth = img.width * scale;
          const drawHeight = img.height * scale;
          const x = (size - drawWidth) / 2;
          const y = (size - drawHeight) / 2;
          // 绘制图片
          ctx.drawImage(img, x, y, drawWidth, drawHeight);
          // 绘制边框
          ctx.restore();
          ctx.strokeStyle = "#fff";
          ctx.lineWidth = 2;
          ctx.beginPath();
          ctx.stroke();
        };

        img.onerror = () => {
          // 图片加载失败，绘制默认头像
          this.drawDefaultAvatar(ctx, size);
          console.log("头像加载失败，使用默认头像");
        };

        img.src = this.info.certificateHeadPhoto;
      } else {
        // 没有头像URL，绘制默认头像
        this.drawDefaultAvatar(ctx, size);
        console.log("使用默认头像");
      }
    },

    // 绘制默认头像
    drawDefaultAvatar(ctx, size) {
      // 绘制背景色
      ctx.fillStyle = "#e0e0e0";
      ctx.fillRect(0, 0, size, size);

      // 绘制用户图标
      ctx.fillStyle = "#999";
      ctx.font = `${size * 0.4}px Arial`;
      ctx.textAlign = "center";
      ctx.textBaseline = "middle";
      ctx.fillText("用户", size / 2, size / 2);

      // 绘制边框
      ctx.restore();
      ctx.strokeStyle = "#fff";
      ctx.lineWidth = 2;
      ctx.beginPath();
      ctx.stroke();
    },
  },
};
</script>

<style lang="scss" scoped>
.button-container {
  display: flex;
  justify-content: center;
  gap: 20px;
}

.print {
  width: 120px;
  height: 40px;
  text-align: center;
  line-height: 40px;
  border-radius: 10px;
  color: #fff;
  cursor: pointer;
  background: #3078e1;
}

.education-record {
  background: #fff;
  border-radius: 4px;
  width: 1200px;
  padding: 20px;
  box-sizing: border-box;
  margin: 0 auto;
  margin-bottom: 40px;
  color: #222;
}

.record-title {
  text-align: center;
  font-size: 22px;
  font-weight: bold;
  letter-spacing: 1px;
  padding-bottom: 8px;
}

.info-table {
  width: 100%;
  border-collapse: collapse;
  margin-bottom: 0;
}

.info-table td {
  padding: 4px 8px;
  font-size: 15px;
  background: #fff;
}

.avatar-cell {
  width: 100px;
  vertical-align: middle;
  background: #fff;
}

.avatar {
  width: 110px;
  // height: 110px;
  object-fit: cover;
  margin: 8px 0;
}

.qr-cell {
  width: 100px;
  text-align: center;
  vertical-align: middle;
  background: #fff;
}

.qr {
  width: 80px;
  height: 80px;
  margin: 8px 0;
}

.label-cell {
  background: #f5f7fa;
  font-weight: bold;
  width: 60px;
  text-align: center;
}

.value-cell {
  width: 100px;
  text-align: center;
}

.title-table {
  width: 100%;
  border-collapse: collapse;
  margin-bottom: 8px;
}

.title-table td {
  padding: 6px 8px;
  font-size: 15px;
  background: #fff;
  text-align: center;
}

.title-label {
  background: #f5f7fa;
  font-weight: bold;
  width: 120px;
}

.section-title {
  font-weight: bold;
  font-size: 16px;
  margin: 10px 0 2px 0;
}

.section-desc {
  font-size: 14px;
  margin-bottom: 6px;
}

.subject-table {
  width: 100%;
  border-collapse: collapse;
  margin-bottom: 8px;
}

.subject-table td {
  padding: 4px 6px;
  font-size: 14px;
  text-align: center;
  background: #fff;
}

.subject-header td {
  background: #f5f7fa;
  font-weight: bold;
}

.stat-table {
  width: 100%;
  border-collapse: collapse;
  margin-bottom: 8px;
  margin-top: 8px;
}

.stat-table td {
  padding: 6px 8px;
  font-size: 15px;
  text-align: center;
  background: #fff;
}

.stat-label {
  background: #f5f7fa;
  font-weight: bold;
}

.audit-table {
  width: 100%;
  border-collapse: collapse;
  margin-top: 8px;
}

.audit-table td {
  padding: 10px 0 10px 10px;
  min-height: 40px;
  text-align: center;
  font-size: 15px;
  background: #fff;
}

.audit-header td {
  font-weight: bold;
  background: #f5f7fa;
}

.stat-audit-table {
  width: 100%;
  border-collapse: collapse;
  margin-top: 8px;
  margin-bottom: 8px;
}

.stat-audit-table td {
  padding: 8px 4px;
  font-size: 15px;
  text-align: center;
  background: #fff;
  vertical-align: middle;
}

.stat-audit-table .vertical-label {
  text-align: center;
  font-weight: bold;
  background: #f5f7fa;
  min-width: 40px;
}

.avatarCanvas {
  display: block;
  margin: auto;
}

.qrCanvas {
  display: block;
}
</style>
